// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AccessManagement_wrapper__JXr7J {
  max-width: 600px;
  margin: 0 auto;
  padding: 24px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.07);
}

.AccessManagement_searchForm__ZUgtr {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.AccessManagement_searchInput__vunox {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 16px;
}

.AccessManagement_searchButton__1wQMM {
  padding: 8px 16px;
  background: #2563eb;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.2s;
}
.AccessManagement_searchButton__1wQMM:disabled {
  background: #a5b4fc;
  cursor: not-allowed;
}

.AccessManagement_userList__QvKeI {
  list-style: none;
  padding: 0;
  margin: 0 0 16px 0;
  border: 1px solid #eee;
  border-radius: 6px;
  background: #fafbfc;
}
.AccessManagement_userItem__-plAx {
  padding: 10px 14px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  transition: background 0.15s;
}
.AccessManagement_userItem__-plAx:last-child {
  border-bottom: none;
}
.AccessManagement_userItem__-plAx:hover {
  background: #f1f5f9;
}

.AccessManagement_userCard__1l0ni {
  margin-top: 20px;
  padding: 18px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f9fafb;
}

.AccessManagement_actionButton__M\\+p9U {
  margin-top: 12px;
  padding: 8px 18px;
  background: #059669;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.2s;
}
.AccessManagement_actionButton__M\\+p9U:disabled {
  background: #a7f3d0;
  cursor: not-allowed;
}

.AccessManagement_error__gBMIy {
  color: #dc2626;
  margin: 10px 0;
}
.AccessManagement_success__Ei83i {
  color: #059669;
  margin: 10px 0;
} `, "",{"version":3,"sources":["webpack://./src/components/AdminPage/access-management/AccessManagement.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;AAChB","sourcesContent":[".wrapper {\r\n  max-width: 600px;\r\n  margin: 0 auto;\r\n  padding: 24px;\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.07);\r\n}\r\n\r\n.searchForm {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.searchInput {\r\n  flex: 1;\r\n  padding: 8px 12px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 6px;\r\n  font-size: 16px;\r\n}\r\n\r\n.searchButton {\r\n  padding: 8px 16px;\r\n  background: #2563eb;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  transition: background 0.2s;\r\n}\r\n.searchButton:disabled {\r\n  background: #a5b4fc;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.userList {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0 0 16px 0;\r\n  border: 1px solid #eee;\r\n  border-radius: 6px;\r\n  background: #fafbfc;\r\n}\r\n.userItem {\r\n  padding: 10px 14px;\r\n  cursor: pointer;\r\n  border-bottom: 1px solid #eee;\r\n  transition: background 0.15s;\r\n}\r\n.userItem:last-child {\r\n  border-bottom: none;\r\n}\r\n.userItem:hover {\r\n  background: #f1f5f9;\r\n}\r\n\r\n.userCard {\r\n  margin-top: 20px;\r\n  padding: 18px 16px;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  background: #f9fafb;\r\n}\r\n\r\n.actionButton {\r\n  margin-top: 12px;\r\n  padding: 8px 18px;\r\n  background: #059669;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n.actionButton:disabled {\r\n  background: #a7f3d0;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.error {\r\n  color: #dc2626;\r\n  margin: 10px 0;\r\n}\r\n.success {\r\n  color: #059669;\r\n  margin: 10px 0;\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `AccessManagement_wrapper__JXr7J`,
	"searchForm": `AccessManagement_searchForm__ZUgtr`,
	"searchInput": `AccessManagement_searchInput__vunox`,
	"searchButton": `AccessManagement_searchButton__1wQMM`,
	"userList": `AccessManagement_userList__QvKeI`,
	"userItem": `AccessManagement_userItem__-plAx`,
	"userCard": `AccessManagement_userCard__1l0ni`,
	"actionButton": `AccessManagement_actionButton__M+p9U`,
	"error": `AccessManagement_error__gBMIy`,
	"success": `AccessManagement_success__Ei83i`
};
export default ___CSS_LOADER_EXPORT___;
